const origin = window.location.origin;

// 测试环境
export const isTest = /.qa|(\.qa)/.test(origin);

// 开发环境
export const isDev = /.dev|(\.dev)/.test(origin);

// release 环境
export const isRelease = /.release|(\.release)/.test(origin);

// 生产环境
export const isProd = !(isTest || isDev || !isRelease);
